import { render, staticRenderFns } from "./import-tenant-data.vue?vue&type=template&id=50084a6a&"
import script from "./import-tenant-data.vue?vue&type=script&lang=ts&"
export * from "./import-tenant-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports